import { FC, SVGProps } from 'react';
import { ReactComponent as Card } from '../assets/icon/card.svg';
import { ReactComponent as FAQ } from '../assets/icon/faq.svg';
import { ReactComponent as Gift } from '../assets/icon/gift.svg';
import { ReactComponent as Guide } from '../assets/icon/guide.svg';
import { ReactComponent as FAQ2 } from '../assets/icon/icon_FAQ2.svg';
import { ReactComponent as Guide2 } from '../assets/icon/icon_guide.svg';
import { ReactComponent as Naire } from '../assets/icon/naire.svg';
import { ReactComponent as Order } from '../assets/icon/order.svg';
import { ReactComponent as PhotoGoods } from '../assets/icon/photogoods.svg';
import { ReactComponent as Shipping } from '../assets/icon/shipping.svg';

enum IconName {
  Guide = 'Guide',
  Guide2 = 'Guide2',
  Gift = 'Gift',
  Naire = 'Naire',
  PhotoGoods = 'PhotoGoods',
  Shipping = 'Shipping',
  Card = 'Card',
  Order = 'Order',
  FAQ = 'FAQ',
  FAQ2 = 'FAQ2',
}

interface Props extends SVGProps<SVGSVGElement> {
  name: string;
}

export const Icon: FC<Props> = ({ name, ...props }) => {
  switch (name) {
    case IconName.Guide:
      return <Guide {...props} />;
    case IconName.Guide2:
      return <Guide2 {...props} />;
    case IconName.Gift:
      return <Gift {...props} />;
    case IconName.Naire:
      return <Naire {...props} />;
    case IconName.PhotoGoods:
      return <PhotoGoods {...props} />;
    case IconName.Shipping:
      return <Shipping {...props} />;
    case IconName.Card:
      return <Card {...props} />;
    case IconName.Order:
      return <Order {...props} />;
    case IconName.FAQ:
      return <FAQ {...props} />;
    case IconName.FAQ2:
      return <FAQ2 {...props} />;
    default:
      return null;
  }
};
